import { useState, Dispatch, SetStateAction } from 'react'
import { useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'
import { MultiSelect, MultiSelectPanelHeaderTemplateParams } from 'primereact/multiselect'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'

// local imports
import './MultiplePlanSideBar.scss'
import { ISideBarModel, VisiblePlan } from 'types/CalendarType'
import { IRemoteOfficeType } from 'types/MainType'
import DateUtil from 'utils/DateUtil'
import { isObjEmpty } from 'utils/Miscellaneous'
import CalendarService from 'service/CalendarService'
import PlanService from 'service/PlanService'
import { actionCreators } from 'state/state-index'
import MultiSidebarContent from './MultiSidebarContent'
import HomeOfficeTypeSelection from 'components/ui/HomeOfficeTypeSelection'
import NotificationDialog from 'components/ui/NotificationDialog'

// assets
import confirmImage from 'assets/images/warning-image.svg'
import successDialogImage from 'assets/images/success-image.svg'
import notificationSuccess from 'assets/images/notification-success.svg'
import remotePlanConfirmImage from 'assets/images/remote-plan-confirm-image.png'
import confirmCalendarImage from 'assets/images/remote-plan-confirm-image.png'

interface ComponentProps {
  refreshCalendar: () => void
  closeSidebar: () => void
  setCongratsDialog: Dispatch<SetStateAction<boolean>>
  model: ISideBarModel[]
  onClickOfficePlan: (arg0: any) => any
  onClickCommonPlan: (arg0: any) => any
  onClickRemotePlan: (arg0: any) => any
  onClickHealthPlan: (arg0: any) => any
  onClickCoiffeurPlan: (arg0: any) => any
  onClickGymPlan: (arg0: any) => any
  onClickLactationPlan: (arg0: any) => any
  onClickMeetingPlan: (arg0: any) => any
  onClickPoolVehiclePlan: (arg0: any) => any
  onClickRedirectOfficePlan: (arg0: any) => any
  selectedType: IRemoteOfficeType | null
  types: IRemoteOfficeType[]
  setSelectedType: any
}

export default function MultiplePlanSideBar(props: ComponentProps) {
  const { t } = useTranslation()

  /* States */
  const dispatch = useDispatch()
  const { cleanDaysState } = bindActionCreators(actionCreators, dispatch)
  const [displayDialog, setDisplayDialog] = useState(false)
  const [displayAlertDialog, setDisplayAlertDialog] = useState(false)
  const [alertRedirectDialog, setAlertRedirectDialog] = useState(false)
  const [deleteDialog, setDeleteDialog] = useState(false)
  const [sideBarModel, setSideBarModel] = useState<ISideBarModel>()
  const [warning, setWarning] = useState('')
  const [reservationConfirmation, setReservationConfirmation] = useState<boolean>(false)
  const [reservationDatesString, setReservationDatesString] = useState<string>('')
  const [selectedPlanTypeItems, setSelectedPlanTypeItems] = useState([])
  const [planTypeItems, setPlanTypeItems] = useState<any[]>([])

  const myPlanList = () => {
    var dayList = props.model.filter((x) => x.day.isChecked)
    dayList.sort((day1, day2) => day1.day.date - day2.day.date)

    let reservationDateList: string[] = []
    dayList.forEach((value) => {
      reservationDateList.push(value.day.date.format('DD.MM.yyyy'))
    })

    let startDate = new Date(dayList[0]?.day?.date)
    let endDate = new Date(dayList[dayList?.length - 1]?.day?.date)
    let hasAway = false
    let hasOffice = false
    let hasCommon = false
    let hasReservation = false

    PlanService.GetMyPlanList(DateUtil.formatDateToString(startDate), DateUtil.formatDateToString(endDate))
      .then((response) => {
        let data = response.data.filter((item) => {
          return reservationDateList.some((value) => {
            return value === item.reservationDateStr
          })
        })
        data.length > 0 &&
          data.map((res) => {
            if (res.planType === 1) {
              hasAway = true
            }
            if (res.planType === 2 || res.planType === 5) {
              hasOffice = true
            }
            if (res.planType === 4 || res.planType === 6) {
              hasCommon = true
            }
            return res
          })

        data.sort((day1, day2) => new Date(day1.reservationDate).getTime() - new Date(day2.reservationDate).getTime())
        let dateString: string = ''
        data.length > 0 &&
          data.map((res, index) => {
            hasReservation = true
            dateString += res.reservationDateStr
            if (index < data.length - 1) {
              dateString += ', '
            }
            return res
          })
        setReservationDatesString(dateString)
      })
      .then(() => {
        let lastReservation =
          (hasAway ? (hasCommon || hasOffice ? ` ${t('plantype.remote')} /` : ` ${t('plantype.remote')}`) : '') +
          (hasOffice ? ' ' + t('plantype.from-office') : '') +
          (hasCommon ? (hasOffice ? `/ ${t('plantype.shared-office')} ` : `${t('plantype.shared-office')} `) : '')

        let newReservation = t('plantype.remote2') + ' '
        let text = t('sidebar.full-remote-text', { reservation: lastReservation, newReservation: newReservation })

        if (!hasReservation) {
          setDisplayDialog(true)
        } else {
          setWarning(text)
          setReservationConfirmation(true)
        }
      })
      .catch((e) => console.log(e))
  }

  let selectedDays = props.model.filter((item) => item.day.isChecked)
  const hasEvent = selectedDays.every((item) => isObjEmpty(item.event))

  const getAlertRedirect = (value: any) => {
    setSideBarModel(value)
    setAlertRedirectDialog(true)
  }

  const alertRedirectUI = () => {
    return (
      <Dialog
        header=""
        visible={alertRedirectDialog}
        position={'center'}
        modal
        style={{ width: '400px' }}
        footer={renderAlertDialogFooter()}
        onHide={() => setAlertRedirectDialog(false)}
        draggable={false}
        resizable={false}>
        <div className="d-flex flex-column of-newplan-confirm-dialog">
          <div className="of-confirm-image">
            <img src={confirmImage} alt="" />
          </div>
          <div className="">
            <p className="of-confirm-info mt-2">{t('sidebar.confirm-header')}</p>
          </div>
          <div className="of-confirm-detail">
            <p>{t('sidebar.table-plan-text')}</p>
          </div>
        </div>
      </Dialog>
    )
  }

  const renderAlertDialogFooter = () => {
    return (
      <div className="d-flex flex-row of-confirm-footer">
        <Button
          label={t('buttons.no')}
          onClick={() => setAlertRedirectDialog(false)}
          className="p-button-outlined w-100"
        />
        <Button
          label={t('buttons.yes')}
          onClick={() => {
            cleanDaysState(true)
            props.onClickRedirectOfficePlan(sideBarModel)
          }}
          className="w-100 of-button-primary"
          disabled={false}
        />
      </div>
    )
  }

  const deleteDialogUI = () => {
    return (
      <Dialog
        header=""
        visible={deleteDialog}
        position={'center'}
        modal
        style={{ width: '400px' }}
        footer={renderDeleteDialogFooter()}
        onHide={() => setDeleteDialog(false)}
        draggable={false}
        resizable={false}>
        <div className="d-flex flex-column of-newplan-confirm-dialog">
          <div className="of-confirm-image">
            <img src={confirmImage} alt="" />
          </div>
          <div className="">
            <p className="of-confirm-info mt-2">{t('overlaypanel-texts.cancel-process')}</p>
          </div>
          <div className="of-confirm-detail">
            <p>{t('sidebar.warning-cancel')}</p>
            <p>{t('sidebar.do-you-accept')}</p>
          </div>
        </div>
      </Dialog>
    )
  }

  const panelHeaderTemplate = (options: MultiSelectPanelHeaderTemplateParams) => {
    return (
      <div className="p-multiselect-header">
        <label className="d-flex align-items-center">
          {options.checkboxElement}
          <span role="button" className="px-2 user-select-none">
            {t('buttons.choose-all')}
          </span>
        </label>
        {options.closeElement}
      </div>
    )
  }

  /* Delete Reservation Dialog Footer Components  */
  const renderDeleteDialogFooter = () => {
    return (
      <div className="d-flex flex-column gap-3 of-confirm-footer">
        {planTypeItems.length > 1 ? (
          <MultiSelect
            selectedItemsLabel={t('most-used-words.all-selected')}
            filter={false}
            scrollHeight="145px"
            className="of-confirm-multiselect"
            maxSelectedLabels={5}
            panelHeaderTemplate={panelHeaderTemplate}
            options={planTypeItems}
            value={selectedPlanTypeItems}
            onChange={(e) => setSelectedPlanTypeItems(e.value)}
            placeholder={t('input-texts.chose-cancel-plantype')}
          />
        ) : null}

        <div className="d-flex justify-content-between gap-3">
          <Button
            label={t('buttons.no')}
            onClick={() => {
              setDeleteDialog(false)
            }}
            style={{ width: '165px' }}
            className="p-button-outlined"
          />
          <Button
            label={t('buttons.yes')}
            onClick={() => {
              deleteMultipleReservation()
              setDeleteDialog(false)
            }}
            style={{ width: '165px' }}
            className="of-button-primary"
            disabled={planTypeItems.length > 1 && !selectedPlanTypeItems.length}
          />
        </div>
      </div>
    )
  }

  const onClickMultipleRemotePlanEvent = () => {
    var filteredModels = props.model.filter((x) => x.day.isChecked)
    let request =
      props.types.length === 0
        ? {
            PlanType: VisiblePlan.HOME_PLAN,
            TableId: 0,
            FloorId: 0,
            ReservationDateList: [] as any,
          }
        : {
            PlanType: VisiblePlan.HOME_PLAN,
            TableId: 0,
            FloorId: 0,
            ReservationDateList: [] as any,
            RemoteOfficeTypeId: props.selectedType?.id,
          }

    filteredModels.forEach((value) => {
      request.ReservationDateList.push(value.day.date)
    })

    CalendarService.saveMultipleReservation(request).then((response) => {
      if (response.status === 200) {
        setDisplayDialog(false)
        setReservationConfirmation(false)
        props.refreshCalendar()
        // Onay dialog'unun kapanma animasyonu bittikten sonra başarı popup'ını aç
        setTimeout(() => setDisplayAlertDialog(true), 350)
      } else {
        console.log(response)
      }
    }).catch((e) => {
      console.log(e)
      setDisplayDialog(false)
    })
  }

  const deleteMultipleReservation = () => {
    let filteredModels = props.model.filter((x: any) => Object.keys(x.event).length !== 0 && x.day.isChecked)

    let request = { ReservationIdList: [] as any }
    let requestDoctor = { DoctorReservationIdList: [] as any }
    let requestCoiffeur = { CoiffeurReservationIdList: [] as any }
    let requestGymSalon = { GymSaloonReservationIdList: [] as any }
    let requestGymGroup = { GroupLessonReservationIdList: [] as any }
    let requestGymTrainer = { GymTrainerReservationIdList: [] as any }
    let requestLactation = { LactationReservationIdList: [] as any }
    let requestMeeting = { MeetingReservationIdList: [] as any }
    let requestPoolVehicle = { PoolVehicleReservationIdList: [] as any }

    if (planTypeItems.length > 1 && selectedPlanTypeItems.length > 0) {
      selectedPlanTypeItems.forEach((selected: any) => {
        if (selected.key === 101) {
          filteredModels.forEach((value) => {
            value.event.doctorReservation?.forEach((f) => {
              requestDoctor.DoctorReservationIdList.push({
                Id: f.id,
                HealthServiceDoctorId: f.healthServiceDoctorId,
              })
            })
          })
        } else if (selected.key === 102) {
          filteredModels.forEach((value) => {
            value.event.coiffeurReservation?.forEach((f) => {
              requestCoiffeur.CoiffeurReservationIdList.push({
                Id: f.id,
                CoiffeurId: f.coiffeurId,
              })
            })
          })
        } else if (selected.key === 103) {
          filteredModels.forEach((value) => {
            value.event.gymSaloonReservation?.forEach((f) => {
              requestGymSalon.GymSaloonReservationIdList.push({
                Id: f.id,
                GymSaloonId: f.gymSaloonId,
              })
            })
          })
        } else if (selected.key === 104) {
          filteredModels.forEach((value) => {
            value.event.gymGroupLessonReservation?.forEach((f) => {
              requestGymGroup.GroupLessonReservationIdList.push({
                Id: f.id,
                GymGroupLessonId: f.gymGroupLessonId,
              })
            })
          })
        } else if (selected.key === 105) {
          filteredModels.forEach((value) => {
            value.event.gymTrainerReservation?.forEach((f) => {
              requestGymTrainer.GymTrainerReservationIdList.push({
                Id: f.id,
                GymTrainerId: f.gymTrainerId,
              })
            })
          })
        } else if (selected.key === 106) {
          filteredModels.forEach((value) => {
            value.event.lactationReservation?.forEach((f) => {
              requestLactation.LactationReservationIdList.push({
                Id: f.id,
                LactationRoomId: f.lactationRoomId,
              })
            })
          })
        } else if (selected.key === 108) {
          filteredModels.forEach((value) => {
            value.event.meetingRoomReservation?.forEach((f) => {
              requestMeeting.MeetingReservationIdList.push({
                Id: f.id,
                MeetingRoomId: f.meetingRoomId,
              })
            })
          })
        } else if (selected.key === 111) {
          filteredModels.forEach((value) => {
            value.event.poolVehicleReservation?.forEach((f) => {
              requestPoolVehicle.PoolVehicleReservationIdList.push({
                Id: f.id,
                PoolVehicleId: f.poolVehicleId,
              })
            })
          })
        } else {
          filteredModels.forEach((value) => {
            if (value.event.id !== 0 && value.event.planType === selected.key) {
              request.ReservationIdList.push({
                ReservationId: value.event.id,
                PlanType: value.event.planType,
              })
            }
          })
        }
      })
    } else if (planTypeItems.length === 1) {
      filteredModels.forEach((value) => {
        if (value.event.id !== 0) {
          request.ReservationIdList.push({
            ReservationId: value.event.id,
            PlanType: value.event.planType,
          })
        }
        value.event.doctorReservation?.forEach((f) => {
          requestDoctor.DoctorReservationIdList.push({
            Id: f.id,
            HealthServiceDoctorId: f.healthServiceDoctorId,
          })
        })
        value.event.coiffeurReservation?.forEach((f) => {
          requestCoiffeur.CoiffeurReservationIdList.push({
            Id: f.id,
            CoiffeurId: f.coiffeurId,
          })
        })
        value.event.gymSaloonReservation?.forEach((f) => {
          requestGymSalon.GymSaloonReservationIdList.push({
            Id: f.id,
            GymSaloonId: f.gymSaloonId,
          })
        })
        value.event.gymGroupLessonReservation?.forEach((f) => {
          requestGymGroup.GroupLessonReservationIdList.push({
            Id: f.id,
            GymGroupLessonId: f.gymGroupLessonId,
          })
        })
        value.event.gymTrainerReservation?.forEach((f) => {
          requestGymTrainer.GymTrainerReservationIdList.push({
            Id: f.id,
            GymTrainerId: f.gymTrainerId,
          })
        })
        value.event.lactationReservation?.forEach((f) => {
          requestLactation.LactationReservationIdList.push({
            Id: f.id,
            LactationRoomId: f.lactationRoomId,
          })
        })
        value.event.meetingRoomReservation?.forEach((f) => {
          requestMeeting.MeetingReservationIdList.push({
            Id: f.id,
            MeetingRoomId: f.meetingRoomId,
          })
        })
        value.event.poolVehicleReservation?.forEach((f) => {
          requestPoolVehicle.PoolVehicleReservationIdList.push({
            Id: f.id,
            PoolVehicleId: f.poolVehicleId,
          })
        })
      })
    }

    // check if reservation type is exists
    const hasNonCampusRes = !!request.ReservationIdList.length
    const hasDoctorRes = !!requestDoctor.DoctorReservationIdList.length
    const hasCoiffeurRes = !!requestCoiffeur.CoiffeurReservationIdList.length
    const hasGymSalonRes = !!requestGymSalon.GymSaloonReservationIdList.length
    const hasGymGroupRes = !!requestGymGroup.GroupLessonReservationIdList.length
    const hasGymTrainerRes = !!requestGymTrainer.GymTrainerReservationIdList.length
    const hasLactationRes = !!requestLactation.LactationReservationIdList.length
    const hasMeetingRes = !!requestMeeting.MeetingReservationIdList.length
    const hasPoolVehicleRes = !!requestPoolVehicle.PoolVehicleReservationIdList.length

    //ayrıca servis yazılacak plantype a göre datayı silecek.
    // 2 tane bildirim tipi seçili ise birisi başarılı bir şekilde silindi 2.silinemezse transaction yapılamadı. uayarı vermek sıkıntı.
    const successResponse = () => {
      props?.closeSidebar()
      props?.setCongratsDialog(true)
    }

    if (hasNonCampusRes) {
      CalendarService.deleteMultipleReservation(request).then((_response) => {
        successResponse()
      })
    }
    if (hasDoctorRes) {
      CalendarService.deleteMultipleDoctorReservation(requestDoctor).then((_response) => {
        successResponse()
      })
    }
    if (hasCoiffeurRes) {
      CalendarService.deleteMultipleCoiffeurReservation(requestCoiffeur).then((_response) => {
        successResponse()
      })
    }
    if (hasGymSalonRes) {
      CalendarService.deleteMultipleGymSalonRes(requestGymSalon).then((_response) => {
        successResponse()
      })
    }
    if (hasGymGroupRes) {
      CalendarService.deleteMultipleGymGroupRes(requestGymGroup).then((_response) => {
        successResponse()
      })
    }
    if (hasGymTrainerRes) {
      CalendarService.deleteMultipleGymTrainerRes(requestGymTrainer).then((_response) => {
        successResponse()
      })
    }
    if (hasLactationRes) {
      CalendarService.deleteMultipleLactationRes(requestLactation).then((_response) => {
        successResponse()
      })
    }
    if (hasMeetingRes) {
      CalendarService.deleteMultipleMeetingRes(requestMeeting).then((_response) => {
        successResponse()
      })
    }
    if (hasPoolVehicleRes) {
      CalendarService.deleteMultiplePoolVehicleRes(requestPoolVehicle).then((_response) => {
        successResponse()
      })
    } else {
      props?.setCongratsDialog(false)
    }
  }

  const renderFooter = (name: any) => {
    return (
      <div className="d-flex flex-row of-confirm-footer">
        <Button label={t('buttons.cancel')} onClick={onHide} className="p-button-outlined w-100" />
        <Button
          label={t('buttons.confirm')}
          onClick={() => onClickMultipleRemotePlanEvent()}
          className="w-100 of-button-primary"
          disabled={false}
        />
      </div>
    )
  }

  const closeAlertDialog = () => {
    setDisplayAlertDialog(false)
    props.closeSidebar()
  }

  const alertDialogUI = () => {
    return (
      <Dialog
        header=""
        visible={displayAlertDialog}
        position={'center'}
        modal
        style={{ width: '400px' }}
        footer={
          <div className="d-flex flex-row of-confirm-footer">
            <Button
              label={t('buttons.ok')}
              onClick={closeAlertDialog}
              className="w-100 of-button-primary"
            />
          </div>
        }
        onHide={closeAlertDialog}
        draggable={false}
        resizable={false}>
        <div className="d-flex flex-column of-newplan-confirm-dialog">
          <div className="of-confirm-image">
            <img src={notificationSuccess} alt="" />
          </div>
          <div className="">
            <p className="of-confirm-info">{t('dashboard.remote-office-notification')}</p>
          </div>
          <div className="of-confirm-detail">
            <p>{t('success-text.remote-office-success')}</p>
          </div>
        </div>
      </Dialog>
    )
  }

  const onHide = () => setDisplayDialog(false)

  return (
    <div className="of-office-sidebar-container multiple">
      <div className="text-center">
        <p className="of-sidebar-header">{t('sidebar.chosen-day-detail')}</p>
        <p className="of-sidebar-description">{t('sidebar.previous-screen-warning')}</p>
      </div>

      {/* Service Notify & Buttons */}
      <MultiSidebarContent
        hasEvent={hasEvent}
        model={props?.model}
        myPlanList={myPlanList}
        setPlanTypeItems={setPlanTypeItems}
        setDeleteDialog={setDeleteDialog}
        onClickOfficePlan={props.onClickOfficePlan}
        onClickHealthPlan={props.onClickHealthPlan}
        onClickCoiffeurPlan={props.onClickCoiffeurPlan}
        onClickGymPlan={props.onClickGymPlan}
        onClickLactationPlan={props.onClickLactationPlan}
        onClickMeetingPlan={props.onClickMeetingPlan}
        onClickPoolVehiclePlan={props.onClickPoolVehiclePlan}
        onClickCommonPlan={props.onClickCommonPlan}
        onClickRemotePlan={props.onClickRemotePlan}
        onClickRedirectOfficePlan={props.onClickRedirectOfficePlan}
        getAlertRedirect={getAlertRedirect}
        refreshCalendar={props.refreshCalendar}
      />
      {/* Notify & Buttons */}

      {/* Dialogs */}
      <Dialog
        blockScroll
        modal
        header=""
        position={'center'}
        visible={displayDialog}
        style={{ width: '400px' }}
        footer={renderFooter('displayPosition')}
        onHide={onHide}
        draggable={false}
        resizable={false}
        dismissableMask={false}>
        <div className="d-flex flex-column of-newplan-confirm-dialog">
          <div className="of-confirm-image">
            <img src={confirmCalendarImage} alt="" />
          </div>
          <div className="">
            <p className="of-confirm-info">{t('dashboard.remote-office-notification')}</p>
          </div>
          {props.types.length > 0 ? (
            <>
              <div className="mb-3">
                <HomeOfficeTypeSelection
                  selectedType={props.selectedType}
                  setSelectedType={props.setSelectedType}
                  types={props.types}
                />
              </div>
              <div className="of-confirm-detail">
                <p>
                  {t('sidebar.remote-text1')}(
                  {i18next.language === 'tr' ? props.selectedType?.displayedText : props.selectedType?.en}){' '}
                  {t('sidebar.remote-text2')}
                </p>
              </div>
            </>
          ) : (
            <div className="of-confirm-detail">
              <p>
                {t('sidebar.remote-text1')} {t('sidebar.remote-text2')}
              </p>
            </div>
          )}
        </div>
      </Dialog>
      {alertDialogUI()}
      {alertRedirectUI()}
      {deleteDialogUI()}

      <NotificationDialog
        display={reservationConfirmation}
        imgSrc={remotePlanConfirmImage}
        goHomeButton={true}
        selectedType={props.selectedType}
        setSelectedType={props.setSelectedType}
        types={props.types}
        title={t('overlaypanel-texts.confirmation')}
        content={warning}
        firstButtonLabel={t('buttons.confirm')}
        textDate={reservationDatesString}
        onHide={() => {
          setReservationConfirmation(false)
          setWarning('')
        }}
        onSubmit={() => onClickMultipleRemotePlanEvent()}
      />
    </div>
  )
}
